import vinculoColorTokens from "./vinculoColorTokens";

// Tokens semânticos: resolvem automaticamente para light/dark via useColorMode.
// Identidade "Azul aço" (docs/marca/): claro sobre "Claro" #F5F7FA, escuro sobre "Noite" #101923
// com superfícies um degrau acima (#16212D). Contraste AA sobre app-card escuro: texto >= 4.5:1,
// marcas gráficas (pontos, barras) >= 3:1.

import colors from "./foundations/colors";
import { tint } from "./tint";

function toneTokens(name, scale) {
  const tone = colors[scale][300];
  return {
    // Texto e ícone no tom (links, valores, ícones de alerta). "-text" e não "-fg" porque
    // aqui "-fg" já significa texto SOBRE o tom (primary-fg).
    [`${name}-text`]: { default: `${scale}.600`, _dark: `${scale}.300` },
    // Texto mais forte dentro de áreas tonalizadas.
    [`${name}-text-strong`]: { default: `${scale}.700`, _dark: `${scale}.300` },
    [`${name}-subtle`]: { default: `${scale}.50`, _dark: tint(tone, 0.14) },
    [`${name}-subtle-border`]: { default: `${scale}.100`, _dark: tint(tone, 0.32) },
  };
}

const semanticTokens = {
  colors: {
    "app-page": { default: "#F5F7FA", _dark: "#101923" },
    "app-card": { default: "#FFFFFF", _dark: "#16212D" },
    "app-navbar": { default: "#FFFFFF", _dark: "#16212D" },
    "app-sidebar": { default: "#FFFFFF", _dark: "#16212D" },
    "app-border": { default: "#E2E8F0", _dark: "#2A3644" },
    "app-muted": { default: "#EEF3F8", _dark: "#1F2B38" },
    "app-muted-fg": { default: "#5B6878", _dark: "#9AA8B8" },
    "app-fg": { default: "#16202B", _dark: "#F1F5F9" },
    // Cor de marca para preenchimentos (pontos, barras, borda de destaque): o Aço some no
    // fundo escuro, então no escuro a marca vira o Apoio (teal.300, 7,5:1), com texto Noite.
    primary: { default: "brand.500", _dark: "teal.300" },
    "primary-fg": { default: "white", _dark: "#101923" },
    ...toneTokens("accent", "brand"),
    ...toneTokens("success", "success"),
    ...toneTokens("warning", "warning"),
    ...toneTokens("danger", "danger"),
    ...toneTokens("teal", "teal"),
    "chakra-body-bg": { default: "#F5F7FA", _dark: "#101923" },
    "chakra-body-text": { default: "#16202B", _dark: "#F1F5F9" },
    ...vinculoColorTokens,
  },
};

export default semanticTokens;
